module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "whiteWrapper"
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.navigateTab
    },
    model: {
      value: (_vm.current_tab),
      callback: function($$v) {
        _vm.current_tab = $$v
      },
      expression: "current_tab"
    }
  }, [_c('el-tab-pane', {
    staticStyle: {
      "margin-top": "-20px"
    },
    attrs: {
      "label": "Organizations",
      "name": "organizations"
    }
  }, [(_vm.organizationsLoading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }],
    staticStyle: {
      "background": "transparent"
    }
  }, [_c('br'), _c('br')]) : _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, _vm._l((_vm.organization_members), function(organization_member) {
    return _c('router-link', {
      attrs: {
        "to": '/membership/' + organization_member.id
      }
    }, [_c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-card', {
      staticClass: "box-card border-hover",
      staticStyle: {
        "position": "relative"
      }
    }, [_c('span', {
      staticStyle: {
        "position": "absolute",
        "top": "10px",
        "right": "10px",
        "width": "22px",
        "height": "22px",
        "border-radius": "50%"
      },
      style: ('backgroundColor:' + organization_member.color)
    }), _vm._v(" "), _c('div', {
      staticClass: "text flex"
    }, [_c('div', {
      staticStyle: {
        "width": "45px",
        "height": "45px",
        "border-radius": "50%",
        "border": "solid 1px #ccc",
        "margin-right": "10px",
        "background-size": "cover",
        "background-repeat": "no-repeat",
        "background-position": "center"
      },
      style: ('background-image: url(' + _vm.api_location + organization_member.organization.profile_picture + ')')
    }), _vm._v(" "), _c('div', [_c('h3', {
      staticStyle: {
        "margin-bottom": "0",
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(organization_member.organization.name))]), _vm._v("\n\t\t\t\t\t\t\t    \t\t" + _vm._s(organization_member.organization.organization_type.name) + "\n\t\t\t\t\t\t\t    \t")])])])], 1)], 1)
  }), 1)], 1)]), _vm._v(" "), _c('el-tab-pane', {
    staticStyle: {
      "margin-top": "-20px"
    },
    attrs: {
      "label": "Calendar Schedule",
      "name": "calendar_schedule"
    }
  }, [(_vm.calendarLoading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }],
    staticStyle: {
      "background": "transparent"
    }
  }, [_c('br'), _c('br')]) : _c('div', [_c('el-select', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    model: {
      value: (_vm.calendar_data_type),
      callback: function($$v) {
        _vm.calendar_data_type = $$v
      },
      expression: "calendar_data_type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$t('static.members.index.options.businessHours'),
      "value": "businesshours"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$t('static.members.index.options.booking'),
      "value": "bookings"
    }
  })], 1), _vm._v(" "), _c('FullCalendar', {
    ref: "fullCalendar",
    attrs: {
      "minTime": _vm.min_time,
      "slotDuration": _vm.timeslot_gap,
      "selectable": _vm.calendar_data_type == 'bookings',
      "defaultView": "timeGridWeek",
      "events": _vm.events,
      "allDaySlot": false,
      "height": "auto",
      "slotEventOverlap": false,
      "eventRender": _vm.showToolTip,
      "plugins": _vm.calendarPlugins,
      "buttonText": {
        today: _vm.$t('static.members.index.calendar.today')
      },
      "firstDay": 1,
      "locale": "nb"
    }
  })], 1)])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-user-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Membership")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61f69bc1","hasScoped":true}!./src/app/pages/withNavigation/membership/index/index.html
// module id = 3036
// module chunks = 1